import * as ambassadorWixAnalyticsModelV3Model from './analytics-model-v3-model-analytics-model.http.js';
import * as ambassadorWixAnalyticsModelV3ModelTypes from './analytics-model-v3-model-analytics-model.types.js';
import * as ambassadorWixAnalyticsModelV3ModelUniversalTypes from './analytics-model-v3-model-analytics-model.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function queryModelData(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAnalyticsModelV3ModelUniversalTypes.QueryModelDataRequest,
  ambassadorWixAnalyticsModelV3ModelTypes.QueryModelDataRequest,
  ambassadorWixAnalyticsModelV3ModelUniversalTypes.QueryModelDataResponse,
  ambassadorWixAnalyticsModelV3ModelTypes.QueryModelDataResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAnalyticsModelV3Model.queryModelData(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/model-api/query-data',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getModel(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAnalyticsModelV3ModelUniversalTypes.GetModelRequest,
  ambassadorWixAnalyticsModelV3ModelTypes.GetModelRequest,
  ambassadorWixAnalyticsModelV3ModelUniversalTypes.GetModelResponse,
  ambassadorWixAnalyticsModelV3ModelTypes.GetModelResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAnalyticsModelV3Model.getModel(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/model-api/get',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listModels(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixAnalyticsModelV3ModelUniversalTypes.ListModelsRequest,
  ambassadorWixAnalyticsModelV3ModelTypes.ListModelsRequest,
  ambassadorWixAnalyticsModelV3ModelUniversalTypes.ListModelsResponse,
  ambassadorWixAnalyticsModelV3ModelTypes.ListModelsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixAnalyticsModelV3Model.listModels(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/model-api/list',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  SemanticModel as SemanticModelOriginal,
  Model as ModelOriginal,
  ModelFilterPrefixEnum as ModelFilterPrefixEnumOriginal,
  ModelFilterPrefixEnumWithLiterals as ModelFilterPrefixEnumWithLiteralsOriginal,
  ModelFilterConditionEnum as ModelFilterConditionEnumOriginal,
  ModelFilterConditionEnumWithLiterals as ModelFilterConditionEnumWithLiteralsOriginal,
  ModelFieldValue as ModelFieldValueOriginal,
  ModelFieldValueValueOneOf as ModelFieldValueValueOneOfOriginal,
  ModelFieldTypeEnum as ModelFieldTypeEnumOriginal,
  ModelFieldTypeEnumWithLiterals as ModelFieldTypeEnumWithLiteralsOriginal,
  ModelFieldFilters as ModelFieldFiltersOriginal,
  FieldVisibilityEnum as FieldVisibilityEnumOriginal,
  FieldVisibilityEnumWithLiterals as FieldVisibilityEnumWithLiteralsOriginal,
  ModelField as ModelFieldOriginal,
  QueryModelDataRequest as QueryModelDataRequestOriginal,
  DateTimeInterval as DateTimeIntervalOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  FieldFilter as FieldFilterOriginal,
  Paging as PagingOriginal,
  Control as ControlOriginal,
  CacheControlEnum as CacheControlEnumOriginal,
  CacheControlEnumWithLiterals as CacheControlEnumWithLiteralsOriginal,
  QueryModelDataResponse as QueryModelDataResponseOriginal,
  ModelFieldDataRow as ModelFieldDataRowOriginal,
  Status as StatusOriginal,
  CacheSatusEnum as CacheSatusEnumOriginal,
  CacheSatusEnumWithLiterals as CacheSatusEnumWithLiteralsOriginal,
  PagingMetadata as PagingMetadataOriginal,
  GetModelRequest as GetModelRequestOriginal,
  GetModelResponse as GetModelResponseOriginal,
  ListModelsRequest as ListModelsRequestOriginal,
  ListModelsResponse as ListModelsResponseOriginal,
  QueryModelDataApplicationErrors as QueryModelDataApplicationErrorsOriginal,
  GetModelApplicationErrors as GetModelApplicationErrorsOriginal,
  ListModelsApplicationErrors as ListModelsApplicationErrorsOriginal,
} from './analytics-model-v3-model-analytics-model.types.js';
